/* eslint-disable import/prefer-default-export */
export const attach = (el, style, duration, ref = {}) => {
  return new Promise((resolve, reject) => {
    const id = window.setTimeout(() => {
      if (el) {
        if (style) {
          el.setAttribute('style', style);
        } else {
          el.removeAttribute('style');
        }
        resolve();
      } else {
        reject();
      }
    }, duration);

    ref.cancel = () => {
      window.clearTimeout(id);
      reject({ canceled: true });
    };
  });
};
